<template>
  <div id="editor-decision-dialog">
    <ipub-model :title="'Recommadation Details'"
                width="684px"
                :visable="isVisable"
                :showFooter="false"
                @cancel="cancel">
      <div class="ipub-p4 mar-b-12 flex">
        <strong style="width: 120px"
                class="tr">Editor</strong>
        <div class="mar-l-20"
             style="width: calc(100% - 140px)">
          <template v-if="inputData.editor">
            {{inputData.editor.firstName}} {{inputData.editor.lastName}} ({{inputData.editor.email}})
          </template>
          <template v-else>- -</template>
        </div>
      </div>
      <div class="ipub-p4 mar-b-12 flex">
        <strong style="width: 120px"
                class="tr">Invited Date</strong>
        <div class="mar-l-20"
             style="width: calc(100% - 140px)">{{inputData.assignedTime?$moment(inputData.assignedTime).format('HH : mm DD / MM / YYYY'):'- -'}}</div>
      </div>
      <div class="ipub-p4 mar-b-12 flex">
        <strong style="width: 120px"
                class="tr">Decision</strong>
        <div :class="'mar-l-20 ipub-decision-status-item--'+inputData.decisionStatus"
             style="width: calc(100% - 140px)">
          {{DECISION_STATUS[inputData.decisionStatus]}}
        </div>
      </div>
      <div class="ipub-p4 mar-b-12 flex">
        <strong style="width: 120px"
                class="tr">Notes for Editors</strong>
        <div class="mar-l-20"
             style="width: calc(100% - 140px)">
          <div v-if="inputData.editorNotes"
               v-html="inputData.editorNotes.replace(/\r\n/g,'<br/>').replace(/\n/g,'<br/>').replace(/\s/g,' ')"></div>
          <template v-else>
            <div class="line-color">No notes or comments.</div>
          </template>
        </div>
      </div>
      <div class="ipub-p4 mar-b-12 flex">
        <strong style="width: 120px"
                class="tr">Notes for Authors</strong>
        <div class="mar-l-20"
             style="width: calc(100% - 140px)">
          <div v-if="inputData.authorNotes"
               v-html="inputData.authorNotes.replace(/\r\n/g,'<br/>').replace(/\n/g,'<br/>').replace(/\s/g,' ')"></div>
          <template v-else>
            <div class="line-color">No notes or comments.</div>
          </template>
        </div>
      </div>
      <div class="ipub-p4 mar-b-12 flex">
        <strong style="width: 120px"
                class="tr">Decision Date</strong>
        <div class="mar-l-20"
             style="width: calc(100% - 140px)">{{inputData.completedTime?$moment(inputData.completedTime).format('HH : mm DD / MM / YYYY'):'- -'}}</div>
      </div>
    </ipub-model>
  </div>
</template>

<script>
import { DECISION_STATUS } from '@/utils/dict'
import { mapGetters } from 'vuex'
export default {
  props: {
    isVisable: {
      type: Boolean,
      default: false,
    },
    inputData: {
      type: Object,
      default () {
        return {}
      }
    },
  },
  data () {
    return {
      DECISION_STATUS
    }
  },
  computed: {
    ...mapGetters({
      domain: 'getDomain',
      reviewRefuse: 'getReviewRefuse'
    })
  },
  methods: {
    cancel () {
      this.$emit('cancel')
    },
  }
}
</script>

<style lang="scss" scoped>
</style>
